export default "__VITE_ASSET__BLiaNLbx__"